import axiosConfig from "./axiosConfig";

interface ReportsResponse {
  executions: Array<{
    status: string;
    startDate: string;
    [key: string]: any;
  }>;
  reports: {
    [reportName: string]: any;
  };
}

const getReports = async (authToken: string): Promise<ReportsResponse> => {
  const { data } = await axiosConfig.get("/reports", {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getReports;
